import React, { InputHTMLAttributes } from 'react';
import Label from '../Label';

type Props = { label: string; id: string; error?: string };

const Input = React.forwardRef<HTMLInputElement, Props & InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
  const { label, error, ...rest } = props;
  return (
    <div className='input'>
      <Label htmlFor={rest.id} text={`${label}${!rest.required ? ' (optional)' : ''}`} />
      <input
        ref={ref}
        {...rest}
        name={rest.name ?? rest.id}
        className='input__element'
        aria-invalid={Boolean(error)}
        aria-describedby={`${rest.id}-error-message`}
      />
      {error ? (
        <div id={`${rest.id}-error-message`} className='input__error-message' role='alert'>
          {error}
        </div>
      ) : null}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
